import { render, staticRenderFns } from "./BookingDelivery.vue?vue&type=template&id=bf05f8c0&scoped=true&"
import script from "./BookingDelivery.vue?vue&type=script&lang=js&"
export * from "./BookingDelivery.vue?vue&type=script&lang=js&"
import style0 from "./BookingDelivery.vue?vue&type=style&index=0&id=bf05f8c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf05f8c0",
  null
  
)

export default component.exports